// extracted by mini-css-extract-plugin
export default {"auroraBackground":"AuroraBackground_auroraBackground__rKB06","aurora":"AuroraBackground_aurora__nFXAv"};